import { render, staticRenderFns } from "./SalesTransactionList.vue?vue&type=template&id=0061c2de&"
import script from "./SalesTransactionList.vue?vue&type=script&lang=js&"
export * from "./SalesTransactionList.vue?vue&type=script&lang=js&"
import style0 from "./SalesTransactionList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports